var _ = require('underscore');
var $ = require('jquery');
var TorsoView = require('backbone-torso/modules/View');
var dropdownTemplate = require('./dropdownTemplate.hbs');

/**
 * View for the dropdown widget. Should be extended so that data
 * can be passed into it. See Initialize.
 *
 * @class DropdownView
 * @constructor
 * @param options {object}. Initialize accepts a "dropdownConfig" to allow passing of dropdown items.
 *   @param [options.tableState=null] {Torso.Cell} table widget state to pass to dropdown items.  Not required by this widget.
 *   @param options.dropdownConfig {Object} dropdown configuration containing menu item information.
 *   @param [options.ariaControls=''} {String} the id of the item controlled by this widget.
 */
module.exports = TorsoView.extend({
  className: 'brec-dropdown-toolbar',
  attributes: function() {
    return {
      'aria-controls': this._ariaControls,
      'aria-label': $.i18n.prop('widget.dropdown.ariaLabel')
    };
  },
  template: dropdownTemplate,

  events: {
    'click [data-dropdown]': '_openDropdown',
    'click [data-dropdown-content]': '_preventClose'
  },

  /**
   * Set active dropdown id
   * @method _setActiveDropdownId
   * @private
   */
  _setActiveDropdownId: function(activeDropdownId) {
    this.set('activeDropdown', activeDropdownId);
  },

  /**
   * Get active dropdown id for comparison
   * @method _getActiveDropdownId
   * @private
   */
  _getActiveDropdownId: function() {
    return this.get('activeDropdown');
  },

  /**
   * Open a dropdown menu
   * @method _openDropdown
   * @param event {object} passed click event
   * @private
   */
  _openDropdown: function(event) {
    var thisMenuId = event.target.getAttribute('aria-owns');

    this.stopListening('dropdownFinished');

    // If this menu is already open
    if (this._getActiveDropdownId() === thisMenuId) {
      this.closeDropdown();
    } else {
      this._setActiveDropdownId(thisMenuId);
      this.listenTo(this._dropdownViews[thisMenuId], 'dropdownFinished', this._waitThenCloseDropdown);
    }

    return false;
  },

  /**
   * Close a dropdown menu
   * @method closeDropdown
   */
  closeDropdown: function() {
    this.set('activeDropdown', '');
    window.clearTimeout(this._closeTimeout); // manual close should clear delayed close
  },

  /**
   * Clicking inside of a dropdown menu should prevent it from closing.
   * @method _preventClose
   */
  _preventClose: function() {
    return false;
  },

  /**
   * If secondsToWait is a positive number, close the dropdown after waiting that many seconds.
   * @method _waitThenCloseDropdown
   * @param secondsToWait the number of seconds to wait before closing. If null, NaN, or negative, the dropdown will not close.
   */
  _waitThenCloseDropdown: function(secondsToWait) {
    if (secondsToWait != null && !isNaN(secondsToWait) && secondsToWait >= 0) {
      window.clearTimeout(this._closeTimeout); // reset timeout; only 1 at a time
      this._closeTimeout = window.setTimeout(_.bind(this.closeDropdown, this), secondsToWait * 1000);
    }
  },

  /**
   * @method constructor
   * @param options {object}. Initialize accepts a "dropdownConfig" to allow passing of dropdown items.
   *   @param [options.tableState=null] {Torso.Cell} table widget state to pass to dropdown items.  Not required by this widget.
   *   @param options.dropdownConfig {Object} dropdown configuration containing menu item information.
   *   @param [options.ariaControls=''] {String} the id of the item controlled by this widget.
   * @override
   */
  constructor: function(options) {
    var defaultOptions = {
      tableState: null,
      dropdownConfig: null,
      ariaControls: ''
    };
    options = _.defaults({}, options, defaultOptions);
    this._ariaControls = options.ariaControls;

    TorsoView.apply(this, arguments);

    this._tableState = options.tableState;

    this.set({
      activeDropdown: '',
      // TODO: saving complex objects like dropdownView can cause NestedModel (the viewState) to have bad performance.
      //       dropdownView (the class) shouldn't be included when adding to the view's state.  Revisit later.
      dropdownMenuItems: options.dropdownConfig.dropdownMenuItems
    });

    var self = this;

    this._dropdownViews = {};

    _.each(options.dropdownConfig.dropdownMenuItems, function(menuItem) {
      var DropdownView = menuItem.dropdownView;
      if (DropdownView) {
        self._dropdownViews[menuItem.dropdownId] = new DropdownView({
          tableState: self._tableState,
          ariaControls: self._ariaControls
        });
      }
    });

    this.listenTo(this.viewState, 'change:activeDropdown', this.render);
    this._closeTimeout = null; // so the timeout doesn't start out undefined
  },

  /**
   * @method attachTrackedViews
   * @override
   */
  attachTrackedViews: function() {
    var self = this;
    var items = this.get('dropdownMenuItems');

    _.each(items, function(menuItem) {
      var attachPoint = 'dropdown-content-' + menuItem.dropdownId;
      var dropdownView = self._dropdownViews[menuItem.dropdownId];
      if (dropdownView) {
        self.attachView(attachPoint, dropdownView);
      }
    });
  }
});
